import { useEffect, useState, useRef } from 'react';

const BOUNDING_OFFSET = 2;

function checkIsTop(rectY, topBounding, offset) {
  const minTopBounding = topBounding - offset;
  const maxTopBounding = topBounding + offset;

  return rectY <= maxTopBounding && topBounding >= minTopBounding;
}

const useStickyStyle = () => {
  const [showStickyStyle, setShowStickyStyle] = useState(false);

  const baseHeaderRef = useRef();
  const tabsRef = useRef();
  const tabTopBoundingRef = useRef();
  const innerHeaderComputedStyle = useRef();

  const baseHeaderHeight = baseHeaderRef.current?.offsetHeight;
  const tabsHeight = tabsRef.current?.offsetHeight;
  const stickyTabsPadding = `0 ${innerHeaderComputedStyle.current?.paddingLeft}`;

  useEffect(() => {
    baseHeaderRef.current = window.document.querySelector('#header');
    const innerHeaderDOM = window.document.querySelector('#header > div');
    innerHeaderComputedStyle.current = getComputedStyle(innerHeaderDOM);
  }, []);

  useEffect(() => {
    const cachedRef = tabTopBoundingRef.current;
    const topBounding = (baseHeaderHeight ?? 0) + 0.5;

    const observer = new IntersectionObserver(
      ([evt]) => {
        const isTop = checkIsTop(
          evt.boundingClientRect.y,
          topBounding,
          BOUNDING_OFFSET,
        );
        setShowStickyStyle(evt.intersectionRatio < 1 && isTop);
      },
      {
        threshold: [1],
        rootMargin: `-${topBounding}px 0px 0px 0px`,
      },
    );

    observer.observe(cachedRef);

    return () => {
      observer.unobserve(cachedRef);
      setShowStickyStyle(false);
    };
  }, [baseHeaderHeight]);

  useEffect(() => {
    if (showStickyStyle) {
      baseHeaderRef.current.style.borderBottom = 'none';
    }
    return () => {
      baseHeaderRef.current.style.borderBottom = '';
    };
  }, [showStickyStyle]);

  return {
    tabsRef,
    tabTopBoundingRef,
    showStickyStyle,
    shadowHeight: tabsRef.current?.clientHeight,
    tabsTop: baseHeaderHeight,
    tabsHeight,
    stickyTabsPadding,
  };
};

export default useStickyStyle;
